// extracted by mini-css-extract-plugin
export default {"container":"Tennis_container--Gmz","stats":"Tennis_stats--Pyl","statsDetails":"Tennis_statsDetails--dgk","percent":"Tennis_percent--PEc"};